<template>
  <div v-if="isMobile() && !hideFooter" class="mobile-footer-copyright">
    AIRspirit © {{ currentYear }}
  </div>
</template>

<script>
import { mobileDetectionMixins } from '@/mixins/mobileDetection'

export default {
  name: 'MobileFooterCopyright',
  mixins: [mobileDetectionMixins],
  data: () => ({
    footerHiddenRoutes: [
      'company-registration-category',
      'company-registration-company',
      'company-registration-confirm-email',
      'company-registration-company-hq',
      'company-registration-company-geocode',
      'company-registration-company-pictures',
      'company-registration-company-qualifications',
      'company-registration-company-aircraft',
      'company-registration-aircraft-geocode',
      'company-registration-aircraft-pictures',
      'company-registration-validation',
      'private-person-registration',
    ],
  }),
  computed: {
    currentYear() {
      return new Date().getFullYear()
    },
    routeName() {
      return this.$route.name
    },
    hideFooter() {
      return (
        this.footerHiddenRoutes.includes(this.routeName) || 
        (this.routeName && this.routeName.startsWith('admin-'))
      )
    },
  },
}
</script>

<style>
.mobile-footer-copyright {
  text-align: center;
  font-size: 14px;
  color: #858584;
  margin-top: 15px;
  margin-bottom: 20px;
  padding-left: 15px;
  padding-right: 15px;
}
</style>
